import { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm, Form } from 'redux-form';

import { FormError } from 'common/components/layout';
import { updateReservationCart } from 'redux/reservationCart/actions';

import Email from './components/Email';
import Notes from './components/Notes';
import { validateCustomerNotLoggedIn } from './validators';

class CustomerNotLoggedIn extends Component {
  handleSubmit = (form) => {
    const { props } = this;
    const data = transformData(form);
    const successFunction = () => {
      props.onEdit('payment');
    };
    props.updateReservationCart(data, successFunction);
  };

  render() {
    const { handleSubmit, form, reservationCart } = this.props;
    return (
      <Form
        onSubmit={handleSubmit(this.handleSubmit)}
        className="c7-form"
        method="post"
      >
        <FormError formName={form} />
        <Email />
        <Notes reservationCart={reservationCart} />
        <div className="c7-checkout__content__buttons">
          <button className="c7-button" type="submit">
            Continue to payment method
          </button>
          <a href="/reservation/availability">Return to availability</a>
        </div>
      </Form>
    );
  }
}

const transformData = (values) => {
  const data = {
    email: values.email,
    notes: values.notes
  };

  return data;
};

const validate = (values) => {
  const data = transformData(values);
  const errors = validateCustomerNotLoggedIn(data);
  return errors;
};

const mapStateToProps = (state) => {
  const reservationCart = state.reservationCart.data;
  let initialValues = {};
  if (reservationCart) {
    initialValues = state.reservationCart.data;
    initialValues.isNotes = !!reservationCart.notes;
  }
  return {
    initialValues
  };
};

CustomerNotLoggedIn = reduxForm({
  form: 'customerNotLoggedIn',
  enableReinitialize: true,
  onSubmitFail: (err, dispatch) => {
    dispatch({ type: 'ADD_FORM_ERROR', payload: err });
  },
  onSubmitSuccess: (result, dispatch) => {
    dispatch({ type: 'REMOVE_FORM_ERROR' });
  },
  validate
})(CustomerNotLoggedIn);

export default connect(mapStateToProps, { updateReservationCart })(
  CustomerNotLoggedIn
);
